import React, { Component } from 'react';
//import './index.css';
import App from './App';
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import reducers from "./store/reducer/index";
//const store = createStore(reducers, applyMiddleware(thunk));
let superProps;
class Services extends Component {
  constructor(props) {
    super(props);
    this.store = createStore(reducers, applyMiddleware(thunk));
    superProps = props;
  }

  render() {
    return (
      <Provider store={this.store}>
        <App {...superProps}/>
      </Provider>)
  };
}

export default Services;
